import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { CommonService } from '../../../services/common.service';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-edit-agent',
  imports: [CommonModule, RouterModule, MaterialModule, FormsModule, ReactiveFormsModule],
  templateUrl: './edit-agent.component.html',
  styleUrl: './edit-agent.component.scss'
})
export class EditAgentComponent {
  agentForm: FormGroup;
  isLoading: any = [];
  base64String: Array<any> = [
    { fileName: '', base64: '', },
    { fileName: '', base64: '', },
    { fileName: '', base64: '', },
    { fileName: '', base64: '', },
    { fileName: '', base64: '', }
  ];

  constructor(
    private commonService: CommonService,
    private fb: FormBuilder,
    private toastService: ToastService,
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<EditAgentComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) { }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.agentForm = this.fb.group({
      name: [''],
      phoneNumber: [''],
      email: [''],
      licenseNumber: [''],
      bankName: [''],
      bankNumber: [''],
      status: [''],
      passportUploadFile: [''],
      governmentIDfile: ['']
    })
  }

  uploadFile(event: any, fileInput: any, index: any) {
    const file = event.target.files[0];
    console.log('fileInput', file)
    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024); // Convert size to MB
      if (file.size > 1024 * 1024) {
        this.toastService.errorToast('File size should be less then 1 MB');
      } else {
        this.base64String[index].fileName = file.name;
        // this.isLoading[index] = true;
        const fileName = `${Date.now()}_${file.name}`
        this.convertToBase64(file, index)
      }
      fileInput.value = '';
      console.log(file)
    }
  }

  convertToBase64(file: File, index: number): void {

    console.log('index', index)
    const reader = new FileReader();

    reader.onload = () => {
      const base64String = reader.result as string;
      this.base64String[index] = { base64: base64String, fileName: file.name };
      console.log(this.base64String)
      console.log('basestring array', this.base64String);
    };
    reader.readAsDataURL(file);
  }

  getFileType(url: any) {
    return this.commonService.getFileType(url);
  }

  // Method to open the image in a new tab
  openImageInNewTab(imageUrl: string): void {
    const styleSheet = `
      <style>
        .flex-center {
          display: flex !important;
          justify-content: center !important;
          align-items: center !important;
          height: 100vh !important;  /* Set height to 100% of the viewport */
          margin: 0;
        }
        img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;  /* Ensure the image is fully contained */
        }
      </style>`;

    const imageHtml = `
      <div class="flex-center">
        <img src="${imageUrl}" />
      </div>`;

    // Open a new tab and set the image as the src
    const newTab: any = window.open();
    newTab.document.head.innerHTML = styleSheet;
    newTab.document.body.innerHTML = imageHtml;
  }


  getDocumentUrl(documentUrl: string) {
    if (documentUrl) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(`https://docs.google.com/gview?url=${documentUrl}&embedded=true`);
    }
    return null;
  }

  // Sanitize the base64 URL for embedding in iframe
  getSafeBase64Url(base64: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(base64);
  }

  openInNewTab(base64: string): void {
    const newTab = window.open();  // Open a new tab

    if (newTab) {
      // Create the URL using the Base64 string
      const url = base64;

      // Write HTML content for the new tab
      newTab.document.write(`
        <html>
          <head>
            <title>PDF Viewer</title>
          </head>
          <body>
            <embed src="${url}" type="application/pdf" width="100%" height="100%">
          </body>
        </html>
      `);
      newTab.document.close();
    }
  }
}
